'use client';
import { Accordion as SharedAccordion } from '@launchstore/shared-puck';
import type { AccordionProps } from '@launchstore/shared-puck';
export const Accordion: any = SharedAccordion;
export type { AccordionProps };
export default Accordion;
